import { asyncComponent } from '@jaredpalmer/after';
import { getBaseOnlineAppUrl } from './util/config';

const routes = [
  {
    path: '/',
    exact: true,
    component: asyncComponent({
      loader: () => import(/* webpackPreload: true */ './pages/Home/Home'),
    }),
  },
  {
    path: '/direct-lending/',
    exact: true,
    component: asyncComponent({
      loader: () => import(/* webpackPrefetch: true */ './pages/DirectLending'),
    }),
  },
  {
    path: '/home-loans',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/MortgagesAndLoans/MortgagesAndLoans'
        ),
    }),
  },
  {
    path: '/home-owning',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPrefetch: true */ './pages/HomeOwning/HomeOwning'),
    }),
  },
  {
    path: '/portfolio-home-loan/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/PortfolioMortgage/PortfolioMortgage'
        ),
    }),
  },
  {
    path: '/fha-mortgage',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/FHAMortgage/FHAMortgage'),
    }),
  },
  {
    path: '/land-home-mortgage',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/LandAndHomeMortgage/LandAndHomeMortgage'
        ),
    }),
  },
  {
    path: '/biweekly-mortgage',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/BiweeklyAdvantage/BiweeklyAdvantage'
        ),
    }),
  },
  {
    path: '/fresh-start-home-loan',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/FreshStartHomeLoan/FreshStartHomeLoan'
        ),
    }),
  },
  {
    paths: ['/contractor-enroll', '/ce'],
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */

          './pages/ContractorEnroll/ContractorEnroll'
        ),
    }),
  },
  {
    paths: ['/contractor-enroll/contact-us', '/ce/contact-us'],
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */

          './pages/ContractorEnroll/ContactUs'
        ),
    }),
  },
  {
    paths: ['/contractor-enroll/thank-you', '/ce/thank-you'],
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */

          './pages/ContractorEnroll/ThankYou'
        ),
    }),
  },
  {
    paths: ['/cl', '/community-lending'],
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/CommercialLending/CommercialLending'
        ),
    }),
  },
  {
    paths: ['/cl/inquiry-form', '/commercial-lending/inquiry-form'],
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */

          './pages/CommercialLendingApplication/CommercialLendingApplication'
        ),
    }),
  },
  {
    path: '/payment-options',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/PaymentOptions/PaymentOptions'
        ),
    }),
  },
  {
    path: '/fico-score/',
    exact: true,
    component: asyncComponent({
      loader: () => import(/* webpackPreload: true */ './pages/FICO/FICO'),
    }),
  },
  {
    path: '/home-buying',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/Homeownership/Homeownership'
        ),
    }),
  },
  {
    path: '/find-a-home',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/FindAHomeCenter/FindAHomeCenter'
        ),
    }),
  },
  {
    path: '/calculators',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/Calculators/Calculators'),
    }),
  },
  {
    path: '/calculators/mortgage-calculator/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/MortgageCalculator/MortgageCalculator'
        ),
    }),
  },
  {
    path: '/calculators/early-payoff-calculator',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/EarlyPayoffCalculator/EarlyPayoffCalculator'
        ),
    }),
  },
  {
    path: '/calculators/amortization-calculator/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/AmortizationCalculator/AmortizationCalculator'
        ),
    }),
  },
  {
    path: '/calculators/extra-monthly-principal/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/MonthlyExtraPrincipal/MonthlyExtraPrincipal'
        ),
    }),
  },
  {
    path: '/calculators/biweekly-extra-principal/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/BiweeklyExtraPrincipal/BiweeklyExtraPrincipal'
        ),
    }),
  },
  {
    path: '/resources/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/Resources/Resources'),
    }),
  },
  {
    path: '/resources/blog/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/FinanceTipsAndTools/FinanceTipsAndTools'
        ),
    }),
  },
  {
    path: '/newsroom/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPrefetch: true */ './pages/Newsroom/Newsroom'),
    }),
  },
  {
    path: '/resources/documents-forms',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/DocumentsAndForms/DocumentsAndForms'
        ),
    }),
  },
  {
    path: '/resources/faqs/',
    exact: true,
    component: asyncComponent({
      loader: () => import(/* webpackPreload: true */ './pages/FAQ/FAQ'),
    }),
  },
  {
    path: '/resources/faqs/:categoryId',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/FAQCategory/FAQCategory'),
    }),
  },
  {
    path: '/resources/faqs/:categoryId/:questionId',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/FAQDetail/FAQDetail'),
    }),
  },
  {
    path: '/alerts/:alertId',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/Alerts/AlertDetail'),
    }),
  },
  {
    path: '/resources/blog/:postId/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/ResourcePost/ResourcePost'),
    }),
  },
  {
    path: '/resources/news/:postId/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/ResourcePost/ResourcePost'),
    }),
  },
  {
    path: '/about/',
    exact: true,
    component: asyncComponent({
      loader: () => import(/* webpackPreload: true */ './pages/About/About'),
    }),
  },
  {
    path: '/contact-us/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/ContactUs/ContactUs'),
    }),
  },
  {
    path: '/sign-in',
    exact: true,
    component: asyncComponent({
      loader: () => import(/* webpackPreload: true */ './pages/SignIn/SignIn'),
    }),
  },
  {
    path: '/apply-today',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/ApplyToday/ApplyToday'),
    }),
  },
  {
    path: '/legal-privacy/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/Privacy/Privacy'),
    }),
  },
  {
    path: '/licensing',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/LicensingIndividual/LicensingIndividual'
        ),
    }),
  },
  {
    path: '/state-licensing',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/LicensingState/LicensingState'
        ),
    }),
  },
  {
    path: '/foreclosure-prevention/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/ForeclosurePrevention/ForeclosurePrevention'
        ),
    }),
  },
  {
    path: '/accessibility',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/Accessibility/Accessibility'
        ),
    }),
  },
  {
    path: '/escrow',
    exact: true,
    component: asyncComponent({
      loader: () => import(/* webpackPreload: true */ './pages/Escrow/Escrow'),
    }),
  },
  {
    path: '/resources/home-care-video-tips/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/HomeCareVideoTips/HomeCareVideoTips'
        ),
    }),
  },
  {
    path: '/tva-energyright-loan/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/EnergyRightLoan/EnergyRightLoan'
        ),
    }),
  },
  {
    path: '/pages/:slug',
    exact: false,
    component: asyncComponent({
      loader: () => import(/* webpackPrefetch: true */ './pages/Pages'),
    }),
  },
  {
    path: '/:teamName/team/:officerUID',
    exact: true,
    component: asyncComponent({
      loader: () => import(/* webpackPrefetch: true */ './pages/BusinessCard'),
    }),
  },
  {
    path: '/discontinued-home-upgrade-loan/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/HugDiscontinued/HugDiscontinued'
        ),
    }),
  },
  {
    path: '/discontinued-tva-energyright-loan/',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPrefetch: true */ './pages/TvaDiscontinued/TvaDiscontinued'
        ),
    }),
  },
  {
    path: '/offline',
    exact: true,
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/Offline/Offline'),
    }),
  },
  {
    path: '*',
    component: asyncComponent({
      loader: () =>
        import(
          /* webpackPreload: true */ './pages/PromoLPTemplate/PromoLPTemplate'
        ),
    }),
  },
  // 404 - Catch All Route
  {
    path: '*',
    component: asyncComponent({
      loader: () =>
        import(/* webpackPreload: true */ './pages/NotFound/NotFound'),
    }),
  },
];

export default routes.reduce((routeList, current) => {
  if (current.path) routeList.push(current);
  if (current.paths) {
    current.paths.forEach(path => {
      routeList.push({
        path,
        ...current,
      });
    });
  }

  return routeList;
}, []);
